var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#13294B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#13294B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.281 31.2735C21.2174 31.2735 21.1544 31.2603 21.0961 31.2348C21.0377 31.2093 20.9853 31.172 20.9421 31.1252L11.8043 21.2407C11.7433 21.1748 11.703 21.0926 11.6881 21.0041C11.6731 20.9156 11.6844 20.8247 11.7203 20.7424C11.7563 20.6602 11.8154 20.5903 11.8905 20.5411C11.9656 20.492 12.0534 20.4659 12.1432 20.4659H16.5416C16.6077 20.4659 16.6729 20.48 16.733 20.5074C16.7931 20.5348 16.8467 20.5748 16.89 20.6246L19.9439 24.138C20.274 23.4325 20.9129 22.2578 22.034 20.8264C23.6915 18.7102 26.7745 15.598 32.0491 12.7885C32.1511 12.7342 32.2697 12.7202 32.3815 12.749C32.4934 12.7779 32.5903 12.8477 32.6532 12.9446C32.7161 13.0415 32.7404 13.1584 32.7212 13.2723C32.7021 13.3862 32.641 13.4888 32.5499 13.5599C32.5298 13.5756 30.4961 15.1771 28.1555 18.1106C26.0014 20.8102 23.1379 25.2243 21.7289 30.9229C21.7042 31.0231 21.6466 31.112 21.5654 31.1756C21.4842 31.2391 21.384 31.2737 21.2809 31.2737L21.281 31.2735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepFinish);
export default __webpack_public_path__ + "static/media/step-finish.607b50afd2b22a2ae2e8d2bff278dae7.svg";
export { ForwardRef as ReactComponent };